// test1858
(1858 && 0);
